export class HelpersMapping {
  mapToApiIsActiveFilter(includeArchived: boolean) {
    return includeArchived === false ? true : null;
  }
}
